import { render } from "./djylResource.vue?vue&type=template&id=73ed4844&scoped=true"
import script from "./djylResource.vue?vue&type=script&lang=js"
export * from "./djylResource.vue?vue&type=script&lang=js"

import "./djylResource.vue?vue&type=style&index=0&id=73ed4844&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ed4844"]])

export default __exports__